module.exports = __webpack_public_path__ + "img/album12_11.0dc2fdcc.jpg";